<template>
  <div>
    <p class="bottom-text">
      Upon signing, I testify that all data submitted is correct. I understand
      that all applications become the property of ASCA. If an application has
      been falsified, the lease will be revoked and fees will not be refunded. I
      further understand that as an owner of an ASCA registered dog, I agree to
      abide by the <ASCAArtIncLink />, <BylawsLink />, and rules of the ASCA Registry, Conformation, Obedience and Stock Dog
      Program and to disciplinary action, if necessary, as determined by the
      ASCA Board of Directors.
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ASCAArtIncLink from "./ASCAArtIncLink.vue";
import BylawsLink from "./BylawsLink.vue";

export default Vue.extend({
  name: "LeaseSignature",
  components: { ASCAArtIncLink, BylawsLink }
});
</script>